import type { QuestionTurnResult } from './shared-responder-v2-core-gateway.types';
import { RESPONDER_PHASES } from './shared-responder-v2-core-session.consts';
import type { ResponderSessionState } from './shared-responder-v2-core-session.types';

function applyQuestionRequired(
  state: ResponderSessionState,
  questionId: string,
  isRequired: boolean
): ResponderSessionState {
  const spec = state.specs[questionId];

  if (spec === undefined || spec.isRequired === isRequired) {
    return state;
  }

  return {
    ...state,
    specs: { ...state.specs, [questionId]: { ...spec, isRequired } },
    steps: state.steps.map((step) =>
      step.questionId === questionId ? { ...step, isRequired } : step
    ),
  };
}

export function applyNextQuestionRequired(
  state: ResponderSessionState,
  result: QuestionTurnResult
): ResponderSessionState {
  if (
    result.nextQuestionId === null ||
    result.nextQuestionIsRequired === undefined
  ) {
    return state;
  }

  return applyQuestionRequired(
    state,
    result.nextQuestionId,
    result.nextQuestionIsRequired
  );
}

export function rejectSkipAsRequired(
  state: ResponderSessionState,
  questionId: string
): ResponderSessionState {
  const questionIndex = state.steps.findIndex(
    (step) => step.questionId === questionId
  );

  if (questionIndex === -1) {
    return state;
  }

  const required = applyQuestionRequired(state, questionId, true);
  const isLeftBehind =
    required.phase === RESPONDER_PHASES.Question &&
    required.currentStepIndex > questionIndex;
  const isOutroFromThisQuestion =
    required.phase === RESPONDER_PHASES.Outro &&
    !required.isComplete &&
    required.currentStepIndex === questionIndex;

  if (!isLeftBehind && !isOutroFromThisQuestion) {
    return required;
  }

  return {
    ...required,
    phase: RESPONDER_PHASES.Question,
    currentStepIndex: questionIndex,
    resumeStepIndex:
      required.resumeStepIndex === required.currentStepIndex
        ? questionIndex
        : required.resumeStepIndex,
    nextQuestionId: null,
  };
}
